import { FormContainer as Container, FormSection as Section } from "../../components/index.js";
import { InputField as Input } from "../../components/index.js";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import FormContext from "../../context/FormContext.js";
import { useContext, useEffect } from 'react';

export default function KinInfoShare() {
    const { injectFormProps } = useInjectFormProps();
    const { formData, updateFormData } = useContext(FormContext);

    useEffect(() => {
        updateFormData({ "kinInfoShare-consent-prompt": "I confirm that I have read and agreed with the above information." })
    }, [])

    return (
        <Container>
            {injectFormProps(
                <>
                    <Section title={"Kindergarten Sharing of Information Consent Form"}>
                        <p>
                            I hereby give my consent for information to be shared between members of the Good Spirit School Division Team for the purpose of determining supports required for Kindergarten programming. Only information pertinent to a child’s development and the needs of their family will be discussed and this information will be kept confidential within the “circle of care”. Members of this team may include staff from:
                        </p>
                        <b>
                            Good Spirit School Division such as:
                        </b>
                        <ul>
                            <li>Kindergarten Teacher
                            </li>
                            <li>School Administrator
                            </li>
                            <li>Early Years Consultant
                            </li>
                            <li>Student Services Consultant
                            </li>
                            <li>Student Support Teacher
                            </li>
                        </ul>
                        <b>
                            SK Health Authority Partners:
                        </b>
                        <ul>
                            <li>Public Health Nurse
                            </li>
                        </ul>
                        <b>
                            Children’s Therapy Program:
                        </b>
                        <ul>
                            <li>Speech Language Pathologist
                            </li>
                            <li>Occupational Therapist
                            </li>
                            <li>Psychologist</li>
                            <li>Physical Therapist
                            </li>
                            <li>Social Worker/Counsellor
                            </li>
                            <li>ASD Consultant
                            </li>
                            <li>Early Childhood Mental Health Therapist
                            </li>
                        </ul>
                        <b>
                            Community Partners:
                        </b>
                        <ul>
                            <li>Community Nursery/Preschool Teacher
                            </li>
                            <li>Community Daycare Director
                            </li>
                            <li>PECIP</li>
                            <li>KidsFirst</li>
                            <li>SIGN</li>
                            <li>Family Resource Centre
                            </li>
                        </ul>
                        <hr>
                        </hr>
                        <Input type={"checkbox"} inputLabel={formData["kinInfoShare-consent-prompt"] ?? "Something went wrong..."} identifier={"kinInfoShare-consent"}></Input>
                    </Section>
                </>
            )}
        </Container>
    );
}
